import {post} from "../modules/ajax";
import Splide from "@splidejs/splide";

let ajaxOuterMenu = null;
export function getOuterMenu(id)
{
    if (ajaxOuterMenu) ajaxOuterMenu.abort();

    return new Promise(resolve => {
        ajaxOuterMenu = post(
            '/ajax/website/outer-menu/get-outer-menu',
            {id: id},
            function(data) {
                resolve(data.html);
            },
            function() {
                resolve(null);
            }
        )
    });
}

export function getOuterMenus()
{
    return new Promise(resolve => {
        post(
            '/ajax/website/outer-menu/get-outer-menus',
            {},
            function(data) {
                resolve(data.html);
            },
            function() {
                resolve(null);
            }
        )
    });
}

export function showLoader()
{
    let container = document.querySelector('#outer-menu-container');

    container.innerHTML += '<div class="outer-menu-loader h-300px d-flex justify-content-center align-items-center"><div class="spinner-border"></div></div>';
}

export function hideLoader()
{
    let container = document.querySelector('#outer-menu-container');
    let loader = container.querySelector('.outer-menu-loader');
    if (loader) loader.remove();
}

export function initHeaderOuterMenuSlider()
{
    let element = document.querySelector('#splide-header-outer-menu');
    if (element) {
        let splide = new Splide(element, {
            pagination: false,
            arrows: true,
            autoWidth: true,
            omitEnd: true,
            perMove: 2
        });

        splide.mount();
    }
}